import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  HostListener,
} from '@angular/core';

@Component({
    selector: 'gl-more-button',
    templateUrl: './more-button.component.html',
    styleUrls: ['./more-button.component.scss'],
    standalone: false
})
export class MoreButtonComponent {
  @Input() isSharedView = false;
  @Input() isMobile = false;
  @Input() showAddLoads = true;
  @Output() deleteAll: EventEmitter<void> = new EventEmitter<void>();
  @Output() addLoads: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('menuContainer', { static: false }) menuContainer: ElementRef;

  public isMenuContainerOpen = false;

  constructor(private elementRef: ElementRef) {}

  public openMenu(): void {
    this.isMenuContainerOpen = !this.isMenuContainerOpen;

    if (this.isMenuContainerOpen) {
      setTimeout(() => {
        this.positionMenuContainer();
      });
    }
  }

  private positionMenuContainer(): void {
    if (!this.menuContainer) return;
    const hostRect: DOMRect = this.elementRef.nativeElement.getBoundingClientRect();
    const menu = this.menuContainer.nativeElement;
    menu.style.position = 'fixed';
    menu.style.top = `${hostRect.top - 8}px`;
    menu.style.left = `${hostRect.left + 53}px`;
    menu.style.zIndex = '1000';

    setTimeout(() => {
      const menuRect = menu.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (menuRect.bottom > viewportHeight) {
        const overflow = menuRect.bottom - viewportHeight;
        menu.style.top = `${hostRect.top - 8 - overflow - 10}px`;
      }
    }, 0);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isMenuContainerOpen) return;

    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isMenuContainerOpen = false;
    }
  }

  public addLoadsToLoadingSpace(): void {
    this.addLoads.emit();
    this.isMenuContainerOpen = false;
  }

  public deleteAllLoads(): void {
    this.deleteAll.emit();
    this.isMenuContainerOpen = false;
  }
}
